import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TimeRangePickerComponent } from '../../components/time-range-picker/time-range-picker.component';

@Component({
  selector: 'formly-time-range-picker',
  standalone: true,
  imports: [ReactiveFormsModule, TimeRangePickerComponent],
  template: `
    <time-range-picker
      [formControl]="formControl"
      [title]="props.label || 'Time Range'"
      [limitStartTime]="props.limitStartTime || 8"
      [limitEndTime]="props.limitEndTime || 20"
    />
  `,
})
export class TimeRangePickerType extends FieldType<FieldTypeConfig> {}